import CustomToggleVisibilityAction from '../cardActions/CustomToggleVisibilityAction';
import CustomShowCardAction from '../cardActions/CustomShowCardAction';
import CustomOpenUrlAction from '../cardActions/CustomOpenUrlAction';
import * as Adaptive from 'adaptivecards';
import * as ActionTypes from './adaptiveCardActionTypes';
import ElementDetails from '../store/schema/ElementDetails';

export default function registerDefaultActions(
    logTelemetryForAction?: (actionEventName: string, elementDetails: ElementDetails) => void
) {
    Adaptive.AdaptiveCard.elementTypeRegistry.unregisterType(ActionTypes.TOGGLE_VISIBILITY_ACTION);
    Adaptive.AdaptiveCard.actionTypeRegistry.registerType(
        ActionTypes.TOGGLE_VISIBILITY_ACTION,
        () => {
            return new CustomToggleVisibilityAction(logTelemetryForAction);
        }
    );

    Adaptive.AdaptiveCard.elementTypeRegistry.unregisterType(ActionTypes.SHOW_CARD_ACTION);
    Adaptive.AdaptiveCard.actionTypeRegistry.registerType(ActionTypes.SHOW_CARD_ACTION, () => {
        return new CustomShowCardAction();
    });

    Adaptive.AdaptiveCard.elementTypeRegistry.unregisterType(ActionTypes.OPEN_URL_ACTION);
    Adaptive.AdaptiveCard.actionTypeRegistry.registerType(ActionTypes.OPEN_URL_ACTION, () => {
        return new CustomOpenUrlAction();
    });
}
